// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";
import { SearchField } from "#/components/search_field/SearchField";
import { ProductFilterBodybuilder } from "../../../../common/interfaces/conversionworld/ProductFilter";

@Component({
  mixins: [template],
  components: {
    SearchField,
  },
})
export default class Bodybuilder extends Vue {
  @Prop({
    default: () => {
      return {};
    },
  })
  public instance!: object;

  @Prop({ default: false })
  public useKonsiFilter!: boolean;

  private searchValue: string = "";
  private factorySolutions: boolean = false;

  get filterStore() {
    if (this.useKonsiFilter) {
      return this.$store.conversionWorldKonsiFilter;
    }

    return this.$store.conversionWorldProductFilter;
  }

  get bodybuilder() {
    if (this.filterStore.filterData) {
      return this.filterStore.filterData.bodybuilder
        .filter((x) => x.count > 0)
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    return [];
  }

  get filteredBodybuilder() {
    let bodybuilder = this.bodybuilder;

    if (this.factorySolutions) {
      bodybuilder = bodybuilder.filter((b) => b.is_vansolution);
    }

    if (this.searchValue && this.searchValue.length > 0) {
      bodybuilder = bodybuilder.filter((b) =>
        b.name.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }

    return bodybuilder;
  }

  get groupedBodybuilder() {
    return Object.values(
      this.filteredBodybuilder.reduce((r, e) => {
        let alphabetLetter = e.name[0];

        if (!r[alphabetLetter]) {
          r[alphabetLetter] = { alphabetLetter, filters: [e] };
        } else {
          r[alphabetLetter].filters.push(e);
        }
        return r;
      }, {})
    );
  }

  private isChecked(bodybuilder: ProductFilterBodybuilder) {
    return this.filterStore.filter.bodybuilder.indexOf(bodybuilder.id) >= 0;
  }

  private onInput(bodybuilder: ProductFilterBodybuilder, value) {
    if (value) {
      if (!this.isChecked(bodybuilder)) {
        this.filterStore.addFilterTag("bodybuilder", bodybuilder);
      }
    } else {
      this.filterStore.removeFilterTag("bodybuilder", bodybuilder);
    }
  }

  @Prop()
  public filters!: [];

  @Prop()
  public mobileSize!: boolean;

  groupedFilters: Array<any> = [];

  mounted() {
    this.groupFilters(this.filters);
  }

  @Watch("filters")
  private filtersChange() {
    this.groupFilters(this.filters);
  }

  private groupFilters(filters) {
    if (!filters) {
      this.groupedFilters = [];
      return;
    }

    this.groupedFilters = [];

    let groups = filters.reduce((r, e) => {
      let alphabetLetter = e.name[0];

      if (!r[alphabetLetter]) {
        r[alphabetLetter] = { alphabetLetter, filters: [e] };
      } else {
        r[alphabetLetter].filters.push(e);
      }
      return r;
    }, {});

    this.groupedFilters = Object.values(groups);
  }

  private change(filter) {
    this.$emit("toogleFilter", "bodybuilder", filter, false);
  }

  private handleInputSearch(e) {
    if (e) this.searchValue = e.target.value;
    let searchResults;

    if (this.factorySolutions) {
      searchResults = this.filters.filter(
        (f: any) =>
          f.name.toLowerCase().includes(this.searchValue.toLowerCase()) &&
          f.is_vansolution == true
      );
    } else {
      searchResults = this.filters.filter((f: any) =>
        f.name.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    }
    this.groupFilters(searchResults);
  }

  private handleChangeRadio(e) {
    this.factorySolutions = !this.factorySolutions;
    this.handleInputSearch(null);
  }
}
